export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11899.ac5f2f9b.jpg";